import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getInspectionSettings, inspection, getTextProcessStatus } from 'store';
import GVCheckbox from 'components/lib/GVCheckbox/GVCheckbox';
import GraphicsMenu from './GraphicsMenu';
import { GraphicsSensitivity } from '@verify/shared-utils';
import styles from './FullPageGraphicZoneSettings.module.css';

const FullPageGraphicZoneSettings = () => {
  const dispatch = useDispatch();
  const documentProcessed = useSelector(getTextProcessStatus);
  const settings = useSelector(getInspectionSettings);
  const inspectionSettings = useSelector(getInspectionSettings);
  const fullPageSelected = settings?.fullPageGraphics === true;

  const toggleGraphicsCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    dispatch(
      inspection.actions.setInspectionSettings({
        fullPageGraphics: isChecked,
        extractEmbeddedImages: isChecked ? false : inspectionSettings.extractEmbeddedImages,
        graphics: {
          ...inspectionSettings.graphics,
          sensitivity: GraphicsSensitivity.STANDARD,
        },
      }),
    );
  };

  return (
    <div className={styles.column}>
      <div className={styles.checkbox}>
        <GVCheckbox
          checked={!!fullPageSelected}
          onChange={toggleGraphicsCheck}
          label="Graphics Pixel Compare"
          data-testid="fullgraph_enable"
          disabled={!documentProcessed || inspectionSettings.extractEmbeddedImages}
        />
      </div>
      {documentProcessed && inspectionSettings.fullPageGraphics && <GraphicsMenu />}
    </div>
  );
};

export default FullPageGraphicZoneSettings;
